import React, { Component } from "react";
import Login from "../authenticate/login";
class Home extends Component {
  state = {};

  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    document.title = "Arpari | Login";
  }

  render() {
    return (
      <Login />
    );
  }
}

export default Home;
